import { Injectable } from "@angular/core";
import { ApiService } from "./Api.service";

@Injectable({
  providedIn: "root",
})
export class WorkshopService {
  constructor(private apiService: ApiService) {}

  /**
   * Public list of workshops (talleres).
   * GET {api_url}/public/workshops
   * Each item includes id, name, level (object), description, days_hours,
   * quota, enable_registration and main_image (small/medium/large).
   */
  async getPublicWorkshops() {
    try {
      const res = await this.apiService.get("public/workshops");
      return res;
    } catch (error) {
      return error;
    }
  }

  /**
   * Public profile of a single workshop.
   * GET {api_url}/public/workshops/{id}
   * Adds teacher, images and registration_text to the list fields.
   */
  async getPublicWorkshop(id: number | string) {
    try {
      const res = await this.apiService.get(`public/workshops/${id}`);
      return res;
    } catch (error) {
      return error;
    }
  }

  async getWorkshop(page: number | null = 1, level: string) {
    // {URL}/api/v1/workshop?page=1&level=inicial
    try {
      let query: string;
      query = `?page=${page}&level_name=${level || ""}`;
      const res = await this.apiService.get("workshop" + query);
      return res;
    } catch (error) {
      return error;
    }
  }
  async getWorkshopHome() {
    try {
      let query: string;
      query = `?page=1&order_name=id&order_type=desc`;
      const res = await this.apiService.get("workshop" + query);
      return res;
    } catch (error) {
      return error;
    }
  }
  async getWorshopProfile(workshopId: any) {
    try {
      const res = await this.apiService.get(`workshop/${workshopId}`);
      return res;
    } catch (error) {
      return error;
    }
  }
  async sendRequest(worskshopId: number, data: any) {
    try {
      const res = await this.apiService.post(`workshop/requestmember`, {
        workshop_id: worskshopId,
        student_id: data,
      });
      return res;
    } catch (error) {
      return error;
    }
  }

  ////////////
  // sections
  ///////////
  async getSections() {
    try {
      let query: string;
      query = `?page=1&per_page=3&order_name=id&order_type=DESC`;
      const res = await this.apiService.get("public/notices" + query);
      return res;
    } catch (error) {
      return error;
    }
  }
  async getSectionProfile(sectionId: any) {
    try {
      const res = await this.apiService.get(`public/notices/${sectionId}`);
      return res;
    } catch (error) {
      return error;
    }
  }
  async getSectionsLevels(levelName: any, page: number | null = 1) {
    try {
      // The public/notices endpoint doesn't filter by level, so we fetch the
      // whole set and filter client-side (see SectionsComponent).
      const query = `?page=${page}&per_page=100&order_name=id&order_type=DESC`;
      const res = await this.apiService.get("public/notices" + query);
      return res;
    } catch (error) {
      return error;
    }
  }
}
